import NextLink from 'next/link';

export interface ILinkPops {
  className?: string;
  target?: string;
  href?: string;
  children?: React.ReactNode;
  passHref?: boolean;
  prefetch?: boolean;
  style?: { [key: string]: string };
}

export const Link = ({
  className,
  href,
  target,
  passHref,
  prefetch,
  children,
  style,
}: ILinkPops) => (
  <NextLink
    className={className}
    href={href}
    passHref={passHref}
    prefetch={prefetch}
    target={target}
    style={style}
  >
    {children}
  </NextLink>
);
